export enum MachinePerformanceType {
    Regeneration = 1,
    Thinning = 2
}

export const MachinePerformanceTypeLabels = {
    [MachinePerformanceType.Regeneration]: "Föryngringsavverkning",
    [MachinePerformanceType.Thinning]: "Gallring"
}